import request from '../utils/request'

/**
 * 获取配音的收费价格
 */
export function getDubPrice () {
  return request({
    url: '/pricing/dubbing_pricing',
    method: 'post'
  })
}

/**
 * 获取vip的收费价格
 */
export function getVipPrice () {
  return request({
    url: '/pricing/vip_pricing',
    method: 'post'
  })
}

/**
 * 配音包列表
 * @return dubbing_pack_product_list[]
 */
export function pricingDubbingPackageList () {
  return request({
    url: '/pricing/dubbing_package_list',
    method: 'post'
  })
}
